export default __webpack_public_path__ + "72c527107db175b3cac7a8c6f5711876.png";